
export default {
  name: 'DfmProductsGrid',
}
